import { toE164Irish } from '@bbbk/schema';

// THE DESK'S DOOR TO A CUSTOMER'S THREAD (deposit-proof AC11): the household's
// own number, promoted to E.164 the way the address book needs (a national
// "087…" is Irish here), with the line already typed. Null when the household
// has no number the app can dial — then the line is there to copy.
export function whatsappTo(phone: string | null | undefined, text: string): string | null {
  const e164 = toE164Irish(phone);
  if (!e164) return null;
  const n = e164.replace(/^\+/, '');
  return text ? `https://wa.me/${n}?text=${encodeURIComponent(text)}` : `https://wa.me/${n}`;
}
